<button class="toggle-btn" (click)="toggleHandler()" [class.toggle-btn-on]="toggle" [disabled]="isDisabled"></button>
